import script from "./ItemsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemsBlock.vue?vue&type=script&setup=true&lang=js"

import "./ItemsBlock.vue?vue&type=style&index=0&id=a10fdbb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a10fdbb2"]])

export default __exports__